import { type ReactNode, useId } from "react";

import { TypoHeader } from "ui/Typo";
import { cn } from "utils/helpers/cn";

interface FieldsetProps {
    children?: ReactNode;
    title?: string;
    className?: string;
    variant?: "grey" | "light";
}

function Fieldset({ children, title, className, variant = "light" }: FieldsetProps) {
    const id = useId();
    const titleWithoutSpaces = title?.replace(/\s+/g, "");
    const titleId = title && `${titleWithoutSpaces}-${id}`;

    return (
        <div
            // biome-ignore lint:
            role="group"
            aria-labelledby={titleId}
            className={cn(
                "flex w-full flex-col gap-n4",
                {
                    "rounded-sm bg-gray3 p-n4 dark:bg-transparent": variant === "grey",
                },
                className,
            )}
        >
            {title && (
                <TypoHeader
                    id={titleId}
                    className={cn({
                        "border-neutral-200 border-b pb-n1 dark:border-primary-foreground": variant === "light",
                    })}
                >
                    {title}
                </TypoHeader>
            )}
            {children}
        </div>
    );
}

export default Fieldset;
